import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getOrFalse, getStringProp } from '@mews/fp';
import { spaceDialogKey } from '../../reducers';
import { parentSelector } from './parentSelector';

const getSpaceDialogState = createSelector(parentSelector, get(spaceDialogKey));
const getSpaceDialogScope = createSelector(getStringProp('scope'), getSpaceDialogState, get);

export const isSpaceDialogOpen = createSelector(
    getSpaceDialogScope,
    getOrFalse<{ isOpen?: boolean }, 'isOpen'>('isOpen')
);
